'use client';

export { default } from './CardActions';
export { default as cardActionsClasses } from './cardActionsClasses';
export * from './cardActionsClasses';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/CardActions/index.js
// module id = 827
// module chunks = 22